export const FETCH_ALL_USERS_REQUEST = 'FETCH_ALL_USERS_REQUEST';
export const FETCH_ALL_USERS_SUCCESS = 'FETCH_ALL_USERS_SUCCESS';
export const FETCH_ALL_USERS_FAILURE = 'FETCH_ALL_USERS_FAILURE';

export const FETCH_USER_BY_ID_REQUEST = 'FETCH_USER_BY_ID_REQUEST';
export const FETCH_USER_BY_ID_SUCCESS = 'FETCH_USER_BY_ID_SUCCESS';
export const FETCH_USER_BY_ID_FAILURE = 'FETCH_USER_BY_ID_FAILURE';

export const fetchAllUsersRequest = (params) => ({
    type: FETCH_ALL_USERS_REQUEST,
    payload: params
});

export const fetchAllUsersSuccess = (users) => ({
    type: FETCH_ALL_USERS_SUCCESS,
    payload: users
});

export const fetchAllUsersFailure = (error) => ({
    type: FETCH_ALL_USERS_FAILURE,
    payload: error
});

export const fetchUserByIdRequest = (id) => ({
    type: FETCH_USER_BY_ID_REQUEST,
    payload: id
});

export const fetchUserByIdSuccess = (user) => ({
    type: FETCH_USER_BY_ID_SUCCESS,
    payload: user
});

export const fetchUserByIdFailure = (error) => ({
    type: FETCH_USER_BY_ID_FAILURE,
    payload: error
});
